// Width and height dimensions for table cells
export const CELL_DIMENSIONS = {
  width: "30px",
  height: "30px",
} as const;
